<template>
  <div>
    <appHeader></appHeader>
    <appModal></appModal>
    <div class="container-fluid transaction-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Transaction Report</h4>
            <hr style="margin-bottom: 0px;" />
            <transactionReportForm></transactionReportForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Modal from "@/components/Modal.vue";
import TransactionReportForm from "@/views/admin/reports/transactionReport/TransactionReportForm.vue";

export default {
  name: "TransactionReport",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    transactionReportForm: TransactionReportForm,
    appModal: Modal,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsTransactionReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.transaction-report {
  // margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

html,
body {
  height: 100%;
}
</style>
